import myAjax from '../../global/libs/myAjax.js';
import $ from 'jquery';

let DEPT_DATA = [];
let DEPT_HIERARCHY = [];

function setDepartmentData(dept_data) {
  DEPT_DATA = dept_data;
}

function getDepartmentList(query_params) {
  //return myAjax("/api/dept/dept_list/", null, 'GET').done(
  let dfd = $.Deferred();
  myAjax('/api/dept/dept_list/', null, 'GET')
    .done((data) => {
      if ('dept' in query_params) {
        DEPT_DATA = data.filter((dt) => dt.id === Number(query_params.dept));
        if (DEPT_DATA.length === 0) {
          // 一致するdeptが無い場合、全リストから選択させる。
          DEPT_DATA = data;
        }
      } else if ('ignore_dept' in query_params && query_params.ignore_dept.toLowerCase() === 'true') {
        // ignore_category_group 指定がある場合、CGによる検索範囲限定を行わない
        DEPT_DATA = [];
      } else {
        // category_group または dept の指定が無い場合、全リストから選択させる
        DEPT_DATA = data;
      }
    })
    .done(function () {
      myAjax('/api/dept/dept_hierarchy/', null, 'GET')
        .done((data) => {
          DEPT_HIERARCHY = data;
          dfd.resolve();
        })
        .fail(() => {
          dfd.reject();
        });
    });
  return dfd.promise();
}

function departmentFilter(dataToFilter) {
  let dept_data = DEPT_DATA;
  if (dept_data && dept_data[0] !== undefined && 'categories' in dept_data[0]) {
    for (var i in dept_data[0].categories) {
      if (dept_data[0].categories[i] === dataToFilter.category) {
        return true;
      }
    }
    return false;
  }
}

export {DEPT_DATA, DEPT_HIERARCHY, setDepartmentData, getDepartmentList, departmentFilter};
